export enum LegendPositionEnum {
  Below = 'below',
  Above = 'above',
  Hide = 'hide',
}
